/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 1/25/2019.
 */

import React, {Component} from 'react';
import {Select} from '@scuf/common';
import {injectIntl} from "react-intl";

class SortInput extends Component {

    render() {
        const {intl} = this.props
        const sortOptions = Object.keys(this.props.sortOptions).map(key => {
            return {
                key: this.props.sortOptions[key],
                value: this.props.sortOptions[key],
                text: intl.formatMessage({id: 'sort.' + key}),
                /**
                 * selected property needs to be set correctly so that after tab and sortOptions change
                 * the correct option is selected. This together with selectOnBlur=false is a fix that
                 * after tab and current sort value change the select was selecting a previous value.
                 */
                selected: this.props.sortOptions[key] === this.props.value,
            }
        });

        const sortText = intl.formatMessage({id: 'filter.sort'}) + sortOptions.find(o => o.value === this.props.value).text;


        return (
            <Select selectOnBlur={false} options={sortOptions} value={this.props.value} onChange={this.props.onChange} fluid text={sortText} />
        )
    }
}

export default injectIntl(SortInput);
